import type { FC, ReactNode } from 'react';

import Button from 'components/_core/Button';
import DetailSidebar, { DetailSidebarProps } from 'components/DetailSidebar';
import ErrorCard from 'components/ErrorCard';

import locales from './locales';
import {
  CancelTeamMemberRequestOptions,
  useCancelTeamMemberRequest,
} from './useCancelTeamMemberRequest';

export interface CancelTeamMemberRequestSidebarProps
  extends DetailSidebarProps {
  requestId: string;
  canCancelRequest?: boolean;
  children: ReactNode;
  onCompleted?: CancelTeamMemberRequestOptions['onCompleted'];
  refetchQueries?: CancelTeamMemberRequestOptions['refetchQueries'];
}

type SubComponents = {
  Body: typeof DetailSidebar.Body;
  Header: typeof DetailSidebar.Header;
};

const CancelTeamMemberRequestSidebar: FC<CancelTeamMemberRequestSidebarProps> &
  SubComponents = ({
  canCancelRequest = true,
  children,
  onCompleted,
  refetchQueries,
  requestId,
  ...props
}) => {
  const [cancelRequest, { error, loading }] = useCancelTeamMemberRequest(
    {
      teamMembersRequestId: requestId,
    },
    {
      onCompleted,
      refetchQueries,
    },
  );

  if (error) {
    return <ErrorCard />;
  }

  return (
    <DetailSidebar {...props}>
      {children}
      {canCancelRequest ? (
        <DetailSidebar.Footer>
          <Button
            isLoading={loading}
            onClick={() => cancelRequest()}
            variant="danger"
          >
            {locales.cancelRequest}
          </Button>
        </DetailSidebar.Footer>
      ) : null}
    </DetailSidebar>
  );
};

CancelTeamMemberRequestSidebar.Body = DetailSidebar.Body;
CancelTeamMemberRequestSidebar.Header = DetailSidebar.Header;

export default CancelTeamMemberRequestSidebar;
